// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/components/HomeScreen.module.css */
.HomeScreen_homeScreen__8-T0O {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: #f0f4f8;
    font-family: 'Montserrat', sans-serif;
    margin: 0;
}

.HomeScreen_content__-xudi {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1 1;
    padding: 20px;
}

.HomeScreen_card__08OEA {
    background-color: white;
    padding: 40px 30px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    text-align: center;
    max-width: 400px;
    width: 100%;
}

.HomeScreen_welcome__lIib9 {
    font-size: 1.8rem;
    color: #074273;
    margin-bottom: 10px;
}

.HomeScreen_role__ipp1r {
    font-size: 1.2rem;
    color: #333;
    margin-bottom: 30px;
}

.HomeScreen_menu__vxVPB {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.HomeScreen_menuButton__hb1Wt {
    padding: 12px 20px;
    background: #074273;
    color: white;
    text-decoration: none;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 500;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.HomeScreen_menuButton__hb1Wt:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Novo estilo para o Header */
header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
    background: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

/* Adiciona um padding ao conteúdo para compensar o header fixo */
.HomeScreen_content__-xudi {
    padding-top: 80px;
    /* Ajuste o valor dependendo da altura do seu header */
}`, "",{"version":3,"sources":["webpack://./src/pages/LIFTrac/HomeScreen/HomeScreen.module.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,yBAAyB;IACzB,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAO;IACP,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA,8BAA8B;AAC9B;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA,iEAAiE;AACjE;IACI,iBAAiB;IACjB,sDAAsD;AAC1D","sourcesContent":["/* frontend/components/HomeScreen.module.css */\r\n.homeScreen {\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-height: 100vh;\r\n    background-color: #f0f4f8;\r\n    font-family: 'Montserrat', sans-serif;\r\n    margin: 0;\r\n}\r\n\r\n.content {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex: 1;\r\n    padding: 20px;\r\n}\r\n\r\n.card {\r\n    background-color: white;\r\n    padding: 40px 30px;\r\n    border-radius: 12px;\r\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\r\n    text-align: center;\r\n    max-width: 400px;\r\n    width: 100%;\r\n}\r\n\r\n.welcome {\r\n    font-size: 1.8rem;\r\n    color: #074273;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.role {\r\n    font-size: 1.2rem;\r\n    color: #333;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.menu {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n}\r\n\r\n.menuButton {\r\n    padding: 12px 20px;\r\n    background: #074273;\r\n    color: white;\r\n    text-decoration: none;\r\n    border-radius: 8px;\r\n    font-size: 1rem;\r\n    font-weight: 500;\r\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n}\r\n\r\n.menuButton:hover {\r\n    transform: translateY(-3px);\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n/* Novo estilo para o Header */\r\nheader {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    z-index: 100;\r\n    background: #fff;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* Adiciona um padding ao conteúdo para compensar o header fixo */\r\n.content {\r\n    padding-top: 80px;\r\n    /* Ajuste o valor dependendo da altura do seu header */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"homeScreen": `HomeScreen_homeScreen__8-T0O`,
	"content": `HomeScreen_content__-xudi`,
	"card": `HomeScreen_card__08OEA`,
	"welcome": `HomeScreen_welcome__lIib9`,
	"role": `HomeScreen_role__ipp1r`,
	"menu": `HomeScreen_menu__vxVPB`,
	"menuButton": `HomeScreen_menuButton__hb1Wt`
};
export default ___CSS_LOADER_EXPORT___;
